// The native host app (the Android wrapper that runs the on-device offline engine) points this POS at the engine's loopback server
// instead of the cloud. It does so at runtime, with either
//   window.__OA_API_BASE__ = 'http://127.0.0.1:8765'        (injected at document start by the host), or
//   localStorage.oa_api_base = 'http://127.0.0.1:8765'      (fallback when the host cannot inject a global)
// Only an on-device loopback origin is ever honoured, so nothing stored in the browser can send the POS (and its bearer token) to another
// server. Anything else is ignored and the build's own base URL is used.

// http://127.0.0.1:<port> or http://localhost:<port>, optionally followed by a plain path prefix. No https, no other host, no
// userinfo, no query or fragment.
const LOOPBACK = /^http:\/\/(127\.0\.0\.1|localhost):([0-9]{1,5})((?:\/[A-Za-z0-9._~-]+)*)\/?$/;

/** The normalised loopback API base (no trailing slash), or null when `value` is not an allowed loopback origin. */
export function loopbackApiBase(value) {
  if (typeof value !== 'string') return null;
  const m = LOOPBACK.exec(value.trim());
  if (!m) return null;
  const port = Number(m[2]);
  if (port < 1 || port > 65535 || m[3].split('/').some((seg) => seg === '.' || seg === '..')) return null;
  try {
    const u = new URL(value.trim());
    if (u.hostname !== m[1] || u.username || u.password || u.search || u.hash) return null;
  } catch {
    return null;
  }
  return `http://${m[1]}:${port}${m[3]}`;
}

/** The base URL to use: a host-provided loopback override if there is a valid one, else `defaultBase` (the build's own, unchanged). */
export function resolveApiBase(defaultBase, win) {
  const read = (fn) => {
    try {
      return fn();
    } catch {
      return null; // storage can throw (blocked, private mode)
    }
  };
  const candidates = [read(() => win && win.__OA_API_BASE__), read(() => win && win.localStorage.getItem('oa_api_base'))];
  for (const c of candidates) {
    const ok = loopbackApiBase(c);
    if (ok) return ok;
  }
  return defaultBase;
}
